import { render, staticRenderFns } from "./PodcastCard.vue?vue&type=template&id=0ea31f4a&scoped=true&"
import script from "./PodcastCard.vue?vue&type=script&lang=js&"
export * from "./PodcastCard.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCard.vue?vue&type=style&index=0&id=0ea31f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea31f4a",
  null
  
)

export default component.exports